module.exports = __webpack_public_path__ + "img/logo_orange.3fa8f952.svg";